import { render, staticRenderFns } from "./FaxTargetSelect.vue?vue&type=template&id=66324359&lang=pug"
import script from "./FaxTargetSelect.vue?vue&type=script&lang=js"
export * from "./FaxTargetSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports